import styled from 'styled-components';

import titleStyles from '../styled';

import DateTitleWithCost from './container';

export default styled(DateTitleWithCost)`
  ${titleStyles}
`;
